import { render, staticRenderFns } from "./fastStats.vue?vue&type=template&id=da1c33ce"
import script from "./fastStats.vue?vue&type=script&lang=js"
export * from "./fastStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports